import $api from "../http";

class MaintenanceSettingsClass {
  async getServiceAvailability() {
    return await $api.get<number>("api/maintenance-settings/status");
  }
}

export const MaintenanceSettingsService = new MaintenanceSettingsClass();
